export const InlineText = ({text, rightValue}) => (
  <p>
    {text} <span className="float-end  fw-bold">{rightValue}</span>
  </p>
);
